var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.289,
    x2: 370.79,
    y1: 156.938,
    y2: 370.439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.036,
    x2: 390.036,
    xlinkHref: "#lg1",
    y1: 173.47,
    y2: 295.47
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.592,
    x2: 266.592,
    xlinkHref: "#lg1",
    y1: 332.329,
    y2: 454.329
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.866,
    x2: 344.866,
    xlinkHref: "#lg1",
    y1: 231.599,
    y2: 353.599
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.909,
    x2: 284.909,
    xlinkHref: "#lg1",
    y1: 308.757,
    y2: 430.757
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.998,
    x2: 238.998,
    xlinkHref: "#lg1",
    y1: 367.839,
    y2: 489.839
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.407,
    x2: 325.407,
    xlinkHref: "#lg1",
    y1: 256.64,
    y2: 378.64
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.575,
    x2: 231.575,
    xlinkHref: "#lg1",
    y1: 377.392,
    y2: 499.392
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.282,
    x2: 379.282,
    xlinkHref: "#lg1",
    y1: 187.309,
    y2: 309.309
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.899,
    x2: 499.899,
    xlinkHref: "#lg1",
    y1: 32.089,
    y2: 154.089
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.909,
    x2: 466.909,
    xlinkHref: "#lg1",
    y1: 74.543,
    y2: 196.543
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.806,
    x2: 461.806,
    xlinkHref: "#lg1",
    y1: 81.111,
    y2: 203.111
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.375,
    x2: 491.375,
    xlinkHref: "#lg1",
    y1: 43.058,
    y2: 165.058
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.039,
    x2: 426.039,
    xlinkHref: "#lg1",
    y1: 127.139,
    y2: 249.139
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.391,
    x2: 377.825,
    xlinkHref: "#lg2",
    y1: 170.578,
    y2: 170.578
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.116,
    x2: 283.127,
    xlinkHref: "#lg2",
    y1: 175.749,
    y2: 175.749
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.761 111.595h-101.899v-82.811c0-10.626-8.614-19.239-19.24-19.239h-79.487c-10.626 0-19.239 8.614-19.239 19.239v82.811h-74.714c-108.119 0-196.816 87.479-196.178 195.596.627 106.286 86.973 192.633 193.26 193.261 108.118.639 195.598-88.058 195.598-196.178v-74.713h101.899c10.626 0 19.239-8.614 19.239-19.239v-79.487c0-10.626-8.614-19.24-19.239-19.24zm-219.866 194.431c0 42.162-34.302 76.464-76.465 76.464s-76.465-34.302-76.465-76.464 34.302-76.465 76.465-76.465h76.465z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m248.996 182.936c6.825 0 12.358-5.533 12.358-12.358s-5.532-12.358-12.358-12.358h-39.362c-6.825 0-12.358 5.533-12.358 12.358s5.532 12.358 12.358 12.358z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.39 415.174c-10.587 5.538-21.899 9.486-33.622 11.734-6.703 1.285-11.094 7.761-9.809 14.464 1.134 5.917 6.313 10.032 12.123 10.032.771 0 1.555-.072 2.341-.223 14.095-2.703 27.695-7.449 40.422-14.106 6.048-3.163 8.386-10.63 5.223-16.678-3.164-6.048-10.63-8.385-16.678-5.223z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.444 206.899c9.635-7.107 20.209-12.751 31.431-16.775 6.424-2.304 9.765-9.38 7.461-15.804-2.304-6.425-9.383-9.761-15.804-7.461-13.486 4.836-26.19 11.616-37.761 20.151-5.492 4.051-6.66 11.788-2.609 17.281 2.423 3.285 6.164 5.023 9.955 5.023 2.548-.001 5.119-.786 7.327-2.415z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.062 292.711c.781.148 1.556.22 2.322.22 5.817 0 11-4.127 12.127-10.051 2.23-11.727 6.16-23.045 11.681-33.643 3.153-6.052.803-13.516-5.25-16.669-6.052-3.152-13.516-.802-16.67 5.251-6.636 12.739-11.361 26.346-14.042 40.444-1.275 6.704 3.127 13.173 9.832 14.448z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.686 338.571c-1.8-6.584-8.59-10.461-15.18-8.661-6.583 1.8-10.46 8.596-8.661 15.179 3.78 13.828 9.562 27.019 17.185 39.208 2.344 3.75 6.37 5.807 10.489 5.807 2.238 0 4.504-.608 6.541-1.882 5.786-3.619 7.544-11.243 3.925-17.03-6.344-10.144-11.154-21.119-14.299-32.621z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.189 339.918c-6.43-2.293-13.498 1.057-15.792 7.486-4.007 11.228-9.635 21.812-16.727 31.457-4.043 5.499-2.864 13.233 2.635 17.277 2.205 1.621 4.768 2.403 7.311 2.403 3.797 0 7.543-1.744 9.965-5.038 8.518-11.584 15.279-24.3 20.094-37.794 2.294-6.428-1.058-13.498-7.486-15.791z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.074 424.822c-11.509-3.127-22.491-7.92-32.644-14.247-5.792-3.61-13.413-1.841-17.023 3.952-3.61 5.792-1.841 13.414 3.952 17.024 12.198 7.603 25.4 13.364 39.236 17.122 1.085.295 2.174.435 3.247.435 5.439 0 10.424-3.62 11.918-9.121 1.79-6.586-2.1-13.376-8.686-15.165z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.879 238.881c-6.825 0-12.358 5.533-12.358 12.358v39.361c0 6.825 5.532 12.358 12.358 12.358s12.358-5.533 12.358-12.358v-39.362c0-6.824-5.533-12.357-12.358-12.357z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.521 9.544v18.806c0 6.825 5.532 12.358 12.358 12.358s12.358-5.533 12.358-12.358v-18.806z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.879 62.807c-6.825 0-12.358 5.533-12.358 12.358v29.792c0 6.825 5.532 12.358 12.358 12.358s12.358-5.533 12.358-12.358v-29.792c0-6.825-5.533-12.358-12.358-12.358z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.139 158.221h-34.399c-6.825 0-12.358 5.533-12.358 12.358s5.532 12.358 12.358 12.358h34.399c6.825 0 12.358-5.533 12.358-12.358s-5.532-12.358-12.358-12.358z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m491.195 158.221c-6.825 0-12.358 5.533-12.358 12.358s5.532 12.358 12.358 12.358h18.805v-24.716z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.879 147.162c-6.825 0-12.358 5.533-12.358 12.358v29.792c0 6.825 5.532 12.358 12.358 12.358s12.358-5.533 12.358-12.358v-29.792c0-6.825-5.533-12.358-12.358-12.358z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m510 210.322v-79.487c0-10.626-8.614-19.239-19.239-19.239h-101.9v117.966h101.899c10.626-.001 19.24-8.615 19.24-19.24z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.103 115.691v124.212c11.278-6.563 24.366-10.342 38.328-10.342h76.465v-117.966h-74.714c-13.721 0-27.127 1.415-40.079 4.096z",
    fill: "url(#SVGID_16_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoad);
export default __webpack_public_path__ + "static/media/icon-road.d6f35ca99c7867bb8c9c292a9ac74723.svg";
export { ForwardRef as ReactComponent };